// locals
import FetchFactory from '../factory';
import User from "~/repository/models/User";
import type {AuthenticatedUser} from "~/repository/types";


export type LoginCredentials = {
    email: string;
    password: string;
};
type LoginResponse = {
    is_new: boolean
    token: string
    user: User
}

export type RegisterCredentials = {
    name: string;
    email: string;
    password: string;
    password_confirmation: string;
};

export type ForgotCredentials = {
    email: string;
};

export type ResetPasswordCredentials = {
    email: string;
    password: string;
    password_confirmation: string;
    token: string;
};

export type SocialAuthRequestBody = {
    code?: string | null;
    email?: string | null;
    age_limit?: boolean | null;
    redirect_uri: string;
    token?: string | null
}


class AuthModule extends FetchFactory {
    private RESOURCE = '/auth';

    async me() {
        return this.call<AuthenticatedUser | null>('get', `${this.RESOURCE}/me`)
    }

    async login(credits: LoginCredentials) {
        return await this.call<LoginResponse>('post', `${this.RESOURCE}/login/email`, credits)
    }

    async signup(credits: RegisterCredentials) {
        return await this.call<LoginResponse>('post', `${this.RESOURCE}/signup`, credits)
    }

    async forgot(credits: ForgotCredentials) {
        return await this.call<any>('post', `${this.RESOURCE}/forgot-password`, credits)
    }

    async reset(credits: ResetPasswordCredentials) {
        return await this.call<any>('post', `${this.RESOURCE}/reset-password`, credits)
    }

    async getSocialRedirectUrl(provider: string, redirectUrl: string): Promise<{ url: string }> {
        return await this.call<{
            url: string
        }>('get', `${this.RESOURCE}/login/redirect/${provider}?redirect_uri=${redirectUrl}`)
    }

    async authUsingSocialProvider(provider: string, data: SocialAuthRequestBody) {
        return await this.call<LoginResponse>('post', `${this.RESOURCE}/login/${provider}`, data)
    }

    async logout() {
        return await this.call<void>('post', `${this.RESOURCE}/logout`)
    }


}

export default AuthModule;